import "core-js/modules/es.array.reduce.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3d9d67c4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "catalog-item"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "catalog-cover"
};
const _hoisted_4 = {
  key: 0,
  class: "catalog-cover-text"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1,
  class: "catalog-cover-text"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Перейти ");

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.6471 9.24984L10.6327 5.55143L11.649 4.44824L17.0762 9.44824L17.675 9.99984L17.0762 10.5514L11.649 15.5514L10.6327 14.4482L14.6471 10.7498H3V9.24984H14.6471Z",
  fill: "black"
})], -1));

const _hoisted_9 = {
  class: "catalog-author"
};
const _hoisted_10 = {
  class: "catalog-name"
};
const _hoisted_11 = {
  class: "catalog-price"
};
const _hoisted_12 = {
  class: "catalog-item"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "catalog-cover"
};
const _hoisted_15 = {
  class: "catalog-cover-text"
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  key: 1
};

const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Перейти ");

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.6471 9.24984L10.6327 5.55143L11.649 4.44824L17.0762 9.44824L17.675 9.99984L17.0762 10.5514L11.649 15.5514L10.6327 14.4482L14.6471 10.7498H3V9.24984H14.6471Z",
  fill: "black"
})], -1));

const _hoisted_20 = {
  class: "catalog-author"
};
const _hoisted_21 = {
  class: "catalog-name"
};
const _hoisted_22 = {
  class: "catalog-price"
};
const _hoisted_23 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _directive_blur = _resolveDirective("blur");

  const _directive_img = _resolveDirective("img");

  return $props.type !== 'custom' ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($props.works, item => {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "catalog-col",
      key: item.id
    }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_router_link, {
      to: {
        name: 'work',
        params: {
          id: item.id
        }
      },
      class: "catalog-img"
    }, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: item.thumbWithPath,
        alt: ""
      }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [item.characteristics.length && item.status_id !== 3 ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.characteristics, (characteristic, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [characteristic.name !== 'Информация' ? (_openBlock(), _createElementBlock("li", _hoisted_5, _toDisplayString(characteristic.name) + ": " + _toDisplayString(characteristic.value), 1)) : _createCommentVNode("", true)], 64);
      }), 128))])) : _createCommentVNode("", true), item.characteristics.length && item.status_id === 3 ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [_createElementVNode("li", null, _toDisplayString(item.characteristics.reduce((old, next) => !old && (next.name === 'Размер' || next.name === 'Размеры') ? next.name + ': ' + next.value : old, '')), 1)])) : _createCommentVNode("", true), _createVNode(_component_router_link, {
        to: {
          name: 'work',
          params: {
            id: item.id
          }
        },
        class: "catalog-cover-button"
      }, {
        default: _withCtx(() => [_hoisted_7, _hoisted_8]),
        _: 2
      }, 1032, ["to"])])]),
      _: 2
    }, 1032, ["to"]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_router_link, {
      to: {
        name: 'author',
        params: {
          id: item.author.id
        }
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.author.name), 1)]),
      _: 2
    }, 1032, ["to"])]), _createElementVNode("div", _hoisted_10, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(item.price), 1)])])), [[_directive_blur, item.status_id === 3 && {
      classes: ['.catalog-img img', '.catalog-name']
    }], [_directive_img, {
      classes: ['.catalog-img img']
    }]]);
  }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList($props.works, item => {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "catalog-col",
      key: item.id
    }, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_router_link, {
      class: "catalog-img",
      to: {
        name: 'user-work',
        params: {
          id: item.id
        }
      }
    }, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: item.thumbWithPath,
        alt: ""
      }, null, 8, _hoisted_13), _createElementVNode("div", _hoisted_14, [_createElementVNode("ul", _hoisted_15, [item.material ? (_openBlock(), _createElementBlock("li", _hoisted_16, " Материал: " + _toDisplayString(item.material), 1)) : _createCommentVNode("", true), item.size ? (_openBlock(), _createElementBlock("li", _hoisted_17, " Размер: " + _toDisplayString(item.size), 1)) : _createCommentVNode("", true)]), _createVNode(_component_router_link, {
        to: {
          name: 'user-work',
          params: {
            id: item.id
          }
        },
        class: "catalog-cover-button"
      }, {
        default: _withCtx(() => [_hoisted_18, _hoisted_19]),
        _: 2
      }, 1032, ["to"])])]),
      _: 2
    }, 1032, ["to"]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_router_link, {
      to: {
        name: 'user-work',
        params: {
          id: item.id
        }
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.author), 1)]),
      _: 2
    }, 1032, ["to"])]), _createElementVNode("div", _hoisted_21, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_22, [item.price ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Цена: " + _toDisplayString(item.price), 1)) : _createCommentVNode("", true)])])])), [[_directive_img, {
      classes: ['.catalog-img img']
    }]]);
  }), 128));
}